import { FormActions } from "../../components/common/FormActions";
import {
  createViewEdit,
  formatDateTime,
  numberFormat,
} from "../../utils/helpers";
import { Tooltip } from "antd";
import { URL_INCIDENT_TICKETING } from "../../utils/urls";

export const useIncidentTicketing = () => {
  const tableColumns = () => [
    {
      id: "ticket_number",
      header: "Ticket Number",
      filter: {
        type: "text",
      },
    },
    {
      id: "title",
      header: "Title",
      filter: {
        type: "text",
      },
    },
    {
      id: "category",
      header: "Category",
    },
    {
      id: "status",
      header: "Status",
      filter: {
        type: "text",
      },
    },
    {
      id: "estimated_duration",
      header: "Estimated Duration",
    },
    {
      id: "estimated_duration_unit",
      header: "Duration Unit",
    },
    {
      id: "rasier_phone_number_info",
      header: "Raiser Phone Number Info",
    },
    {
      id: "actions",
      header: "Actions",
    },
  ];

  const tableData = (data: any) => [
    ...data?.map((item: any) => {
      const row = {
        ...item,
        ticket_number: (
          <Tooltip title={item?.ticket_number}>
            <span style={{ cursor: "pointer" }}>
              {item?.ticket_number?.length > 13
                ? `${item?.ticket_number?.substring(0, 13)}...`
                : item?.ticket_number}
            </span>
          </Tooltip>
        ),
        title: item?.title,
        category: item?.category,
        status: item?.status,
        estimated_duration: item?.estimated_duration,
        estimated_duration_unit: item?.estimated_duration_unit,
        rasier_phone_number_info: item?.rasier_phone_number_info,
        actions: (
          <FormActions
            actions={createViewEdit(
              `${URL_INCIDENT_TICKETING}`,
              item?.id,
              false,
            )}
          />
        ),
      };
      return row;
    }),
  ];
  const externalFilters = [
    {
      id: "account",
      header: "Account",
      filter: { type: "text" },
    },
  ];

  const tableTotals = (data: any) => {
    return {
      amount: numberFormat(data?.metadata?.total_amount),
    };
  };

  const viewData = (item: any) => {
    return {
      ticket_number: item?.ticket_number,
      title: item?.title,
      description: item?.description,
      category: item?.category,
      status: item?.status,
      estimated_duration: item?.estimated_duration,
      estimated_duration_unit: item?.estimated_duration_unit,
      diagnosis: item?.diagnosis,
      backlog_resolution: item?.backlog_resolution,
      permanent_fix: item?.permanent_fix,
      action_taken: item?.action_taken,
      resolution_time: item?.resolution_time,
      rasier_phone_number_info: item?.rasier_phone_number_info,
      created_at: formatDateTime(item?.created_at),
    };
  };

  // const activityFilter = "ledger_record";

  return {
    tableColumns,
    tableData,
    viewData,
    tableTotals,

    externalFilters,
    // activityFilter,
  };
};
